import { useRegisterTokenRefresher } from '../useRegisterTokenRefresher';

interface TokenRefreshProviderProps {
  children: React.ReactNode;
}

/**
 * Registers the token refresher for the app. Under the Token-Mediating Backend
 * model an expired token is refreshed reactively — by the apiClient 401 interceptor
 * and by the WebSocket reconnect path — so we no longer clear a still-refreshable
 * token on startup.
 */
export const TokenRefreshProvider = ({
  children,
}: TokenRefreshProviderProps) => {
  useRegisterTokenRefresher();

  return <>{children}</>;
};
